import React from "react";
import {Route, Switch} from "react-router-dom";

import Login from "./login/Login";
import Menu from "./pages/menu/Menu";
import Dashboard from "./pages/dashboard/Dashboard";

import {ROUTES} from "./utils/RouteConstants";
import MemberForm from "./pages/member/MemberForm";
import MembersTable from "./pages/membersTable/MembersTable";
import NoteForm from "./pages/member/NoteForm";
import DependantForm from "./pages/dependants/DependantForm";
import DependantsScreen from "./pages/dependants/DependantsScreen";
import ExpenseForm from "./pages/ExpenseForm";
import IncomeForm from "./pages/IncomeForm";
import ClaimsForm from "./pages/ClaimsForm";
import PremiumsForm from "./pages/PremiumsForm";
import InvestmentForm from "./pages/InvestmentForm";
import CashAtHandForm from "./pages/CashAtHandForm";
import ReportsScreen from "./pages/reports/ReportsScreen";
import StatementScreen from "./pages/statement/StatementScreen";
import TransactionQuery from "./pages/transactionQuery/TransactionQuery";

export default function Routes() {

    return (
        <Switch>

            <Route exact path={ROUTES.LOGIN} render={() => <Login />} />

            <Route path={ROUTES.DASHBOARD} render={() => (<Menu> <Dashboard /></Menu> )} />

            <Route path={ROUTES.MEMBERS_FORM} render={() => ( <Menu> <MemberForm /> </Menu> )}/>

            <Route path={ROUTES.MEMBERS} render={() => ( <Menu> <MembersTable /> </Menu> )}/>

            <Route path={ROUTES.NOTES_FORM} render={() => ( <Menu> <NoteForm /> </Menu> )}/>

            <Route path={ROUTES.DEPENDANTS_FORM} render={() => ( <Menu> <DependantForm /> </Menu> )}/>

            <Route path={ROUTES.DEPENDANTS} render={() => ( <Menu> <DependantsScreen /> </Menu> )}/>

            <Route path={ROUTES.EXPENSE_FORM} render={() => (<Menu> <ExpenseForm /></Menu> )} />

            <Route path={ROUTES.INCOME_FORM} render={() => (<Menu> <IncomeForm /></Menu> )} />

            <Route path={ROUTES.CLAIMS_FORM} render={() => (<Menu> <ClaimsForm /></Menu> )} />

            <Route path={ROUTES.PREMIUMS_FORM} render={() => (<Menu> <PremiumsForm /></Menu> )} />

            <Route path={ROUTES.INVESTMENTS_FORM} render={() => (<Menu> <InvestmentForm /></Menu> )} />

            <Route path={ROUTES.CASH_AT_HAND_FORM} render={() => (<Menu> <CashAtHandForm /></Menu> )} />

            <Route path={ROUTES.REPORTS} render={() => ( <Menu> <ReportsScreen /> </Menu> )}/>

            <Route path={ROUTES.STATEMENT_SCREEN} render={() => ( <Menu> <StatementScreen /> </Menu> )}/>

            <Route path={ROUTES.QUERY_TRANSACTIONS} render={() => ( <Menu> <TransactionQuery /> </Menu> )}/>

            <Route path={ROUTES.QUERY_TRANSACTIONS} render={() => ( <Menu> <TransactionQuery /> </Menu> )}/>


        </Switch>
    )

}